import React, { Component } from 'react';
import { Link } from 'react-router';

class AdminPage extends Component {
  render() {
    return (
      <div className="AdminPage container">
        <h1>Admin</h1>
        <ul>
          <li><Link to="/app/admin/keys">Steam Keys</Link></li>
          <li><Link to="/app/admin/invites">Invites</Link></li>
        </ul>
        {this.props.children}
      </div>
    );
  }
}

export default AdminPage;



// WEBPACK FOOTER //
// ./src/containers/AdminPage.js